//@import dependencies
import React, {CSSProperties, ReactNode, useState} from 'react'
import { useTranslation } from 'react-i18next'
import { Spinner, Accordion, Card } from 'react-bootstrap'
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import { IoIosAddCircleOutline, IoIosCloseCircleOutline } from 'react-icons/io';
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
import { ICourseSchedulingDetailListItem, ISession } from 'app_types/admin/courseScheduling/courseSchedulingDetailsTypes'
// @end

// @INFO Import services
import DurationFieldService from 'app_services/components/durationFieldService'
// @end

// @INFO Import Styles
import './../courseSchedulingDetailListModule.scss'
import moment from 'moment'

// @ADD Component types
interface ICourseSchedulingDetailListModuleLayoutProps {
  status: null | 'loading' | 'error'
  itemList: ICourseSchedulingDetailListItem[]
}

const CourseSchedulingDetailListModuleLayout: React.FC<ICourseSchedulingDetailListModuleLayoutProps> = (props) => {

  const durationFieldService: DurationFieldService = new DurationFieldService()

  const [activeKey, updateActiveKey] = useState<string | undefined>(undefined)
  const { t } = useTranslation()

  const getSchedule = (session: ISession) => {
    let schedule = ''
    if (session.startDate && session.duration) {
      let endDate = moment(session.startDate).add(session.duration, 'seconds')
      schedule += `${moment(session.startDate).format('DD/MM/YY hh:mm a')} a ${moment(endDate).format('DD/MM/YY hh:mm a')}`
    }
    return schedule
  }

  const getDuration = (session: ISession) => {
    return durationFieldService.getDurationFormated(session.duration, 'short', false)
  }

  const getBody = (item: ICourseSchedulingDetailListItem) => {
    return (
      <div className='item'>
        <b>{t('components.dataTable.headers.course_scheduling.details.course_code')}</b>: {item?.course?.code} <br />
        <b>{t('components.dataTable.headers.course_scheduling.details.course')}</b>: {item?.course?.name} <br />
        <b>{t('components.dataTable.headers.course_scheduling.details.duration')}</b>: {item?.duration_formated} <br />
        <b>{t('components.dataTable.headers.course_scheduling.details.teacher')}</b>: {item?.teacher?.fullname} <br />
        {item.sessions && item.sessions.length > 0 ? (
          <>
            {item.sessions.map((session) => (
              <>
                <b>{t('components.dataTable.headers.course_scheduling.details.startDate')}</b>: {getSchedule(session)},&nbsp;
                <b>{t('labels.duration')}</b>: {getDuration(session)}
                <br />
              </>
            ))}
          </>
        ) : (
          <>
            <b>{t('components.dataTable.headers.course_scheduling.details.startDate')}</b>: {item?.startDate} <br />
            <b>{t('components.dataTable.headers.course_scheduling.details.endDate')}</b>: {item?.endDate}
          </>
        )}
      </div>
    )
  }

  return(
    <div className='course_scheduling_detail_list-component'>
      {props.status === 'loading' ? (
        <Spinner className='spinner-loading' animation='border' />
      ): (
        <>
          {props.itemList.length > 0 ? (
            <Accordion
              activeKey={activeKey}
              onSelect={(_key) => updateActiveKey(_key ? _key : undefined)}
            >
              {props.itemList.map((item: ICourseSchedulingDetailListItem, index: number) => (
                <>
                  <AccordionItem
                    eventKey={index.toString()}
                    title={`${item?.course?.code} - ${item?.course?.name}`}
                    currentKey={activeKey}
                    body={getBody(item)}
                  />
                </>
              ))}

            </Accordion>
          ): (
            <div className='alert alert-info'>
              Aún no se ha programado ningún curso
            </div>
          )}
        </>
      )}
    </div>
  )
}
interface IAccordionItemProps {
  eventKey: string
  title: string
  body?: ReactNode
  // blocks?: any[]
  // items?: {data: any, name: string, category: string}[]
  currentKey?: string
  className?: string
  style?: CSSProperties
  id?: string
}
const AccordionItem: React.FC<IAccordionItemProps> = (props) => {

  return(
    <Card
      className={`accordion_item-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <Accordion.Toggle
        eventKey={props.eventKey}
        className='toggle-accordion-course'
      >
        <TextComponent
          type='title'
          style={{
            fontSize: '.8rem',
            textAlign: 'left'
          }}
        >
          {props.title}
        </TextComponent>
        {props.currentKey === props.eventKey ?
          <IoIosCloseCircleOutline/>
        :
          <IoIosAddCircleOutline/>
        }
      </Accordion.Toggle>
      <Accordion.Collapse
        eventKey={props.eventKey}
      >
        <Card.Body
          className='collapse-accordion-course'
        >
          {props.body}
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}

export default CourseSchedulingDetailListModuleLayout
